import React from 'react';
import ColorSwatch from 'components/commercetools-ui/atoms/color-swatch';
import { HorizontalMore } from 'components/commercetools-ui/organisms/mini-cart';
import { cleanString } from 'helpers/utils/util';
import { MAX_SWATCHES_TO_DISPLAY } from './color-swatches';

type HexColorSwatchesProps = {
  hexCodes: string[];
  ffid?: string;
  productName?: string;
};

const HexColorSwatches: React.FC<HexColorSwatchesProps> = ({ hexCodes, ffid, productName }) => {
  const swatchesToDisplay = hexCodes.length > MAX_SWATCHES_TO_DISPLAY
    ? MAX_SWATCHES_TO_DISPLAY - 1
    : MAX_SWATCHES_TO_DISPLAY;

  return (
    <div className="pointer-events-none flex items-end px-4 sm:gap-4">
      {hexCodes.slice(0, swatchesToDisplay).map((hexCode, index) => (
      <ColorSwatch
        key={`${hexCode}-${index}`}
        hexColors={[hexCode]}
        dataFfid={`tile-${ffid ? ffid + '-' : ''}product-colors-${index}`}
        isProductTile
      />
      ))}

      {hexCodes.length > MAX_SWATCHES_TO_DISPLAY && (
        <div
          data-ffid={`img-${ffid ? ffid + '-' : ''}more-color-tags-${cleanString(productName ?? '')}`}
          className="size-30 flex items-center justify-center"
        >
          <HorizontalMore height={20} width={20} />
        </div>
      )}
    </div>
  );
};

export default HexColorSwatches;